<template>
  <div>
    <div class="page-header clear-filter" filter-color="black3">
      <parallax
        v-bind:useScroll="false"
        class="page-header-image"
        style="background-image:url('/img/img_land.png')"
      ></parallax>
      <div class="container" id="top">
        <div class="row" style="margin-top: 0px;">
          <div
            style="text-align: center; margin-top: 10px; font-size: 1.2em;
            width: 1112px; height: 66px;
                        font-weight: 300;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        color: #000000;
                        background-image: url('/img/bg_search.png')
                        "
          >
            <input
              type="text"
              v-model="inputLandId"
              v-bind:placeholder="$t(`info_landid_placeholder`)"
              style="background-color: transparent; border: none; width: 896px; height: 37px; margin-left: -180px; margin-top: 15px; padding-left: 20px;"
            />
            <div
              style="width: 180px; height: 48px; background-image: url('/img/btn_180.png'); position: relative; right: -922px; top: -43px; text-align: center; color: #fff568; padding-top: 8px; font-size: 1.2em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            cursor: pointer;
            "
              @click="searchLand()"
            >{{$t(`Search`)}}</div>
            <!-- <fg-input v-model="inputLandId" v-bind:placeholder="$t(`info_landid_placeholder`)"></fg-input> -->
          </div>
        </div>
        <div class="row" style="margin-top: 40px;" v-if="landId != '' && no_land == false">
          <div
            style="width: 644px; height: 644px; margin-left: 3px; text-align: left; background-image: url('/img/img_minimap.png')"
          >
            <img
              src="/img/bg_user.png"
              width="20px"
              v-bind:style="{position: 'relative', left:`${landLocation[0]}px`, top: `${landLocation[1]}px`, 'margin-top': '-16px', 'margin-left': '-8px'}"
            />
          </div>
          <div class="land-info-area">
            <div class="land-info-title">
              <h6 class="card-title mb-4">Land')}} #{{landInfo.landId}}</h6>
            </div>
            <table style="width: 100%; margin-top: 24px; text-align: left;">
              <tr style="height: 42px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Dev. Rank')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3">{{landInfo.attributes.devRank}}</h6>
                </td>
              </tr>
              <tr style="height: 42px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Name')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3">{{landInfo.landName}}</h6>
                </td>
              </tr>
              <tr style="height: 76px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Owner')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3" v-if="landInfo.owner != null">
                    <a
                      v-bind:href="getEtherScanUrl(landInfo.owner.address)"
                      target="_blank"
                    >{{landInfo.owner.address}}</a>
                  </h6>
                  <h6 class="card-title3" v-if="landInfo.owner == null">{{$t('not_own')}}</h6>
                </td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Comment')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3">{{landInfo.attributes.profile.comment}}</h6>
                </td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Color')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <div
                    v-bind:style="{width: `24px`, height: `24px`, 'border': '1px solid #000000', 'background-color': `${this.getHexColor(landInfo.attributes.profile.color)}`, 'margin-left':`auto`, 'margin-right':0, 'margin-bottom': '10px'}"
                  ></div>
                </td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Reward')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;"></td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Cumulative')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3">{{landInfo.attributes.stats.token}}ETH</h6>
                </td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Unclaimed')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3">{{landInfo.attributes.storage.token}}ETH</h6>
                </td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Resources')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;"></td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Cumulative')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3">{{landInfo.attributes.stats.resources}}</h6>
                </td>
              </tr>
              <tr style="height: 39px;">
                <td style="width: 30%; padding-left: 10px;">
                  <h6 class="card-title2">{{$t('Unclaimed')}}</h6>
                </td>
                <td style="width: 70%; padding-right: 10px;">
                  <h6 class="card-title3">{{landInfo.attributes.storage.resources}}</h6>
                </td>
              </tr>
            </table>
            <div
              style="text-align: center; margin-top: 60px; 
                        width: 441px; height: 40px;
                        "
            >
              <div
                style="font-weight: 300;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal; color: #fff; font-size: 1.0em;
                        text-decoration: underline;
                        "
              >URL : {{landUrl}}</div>
            </div>
            <div style="width: 180px; height: 48px; background-image: url('/img/btn_180.png'); text-align: center; color: #fff568; padding-top: 8px; font-size: 1.2em; margin: auto;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            cursor: pointer;
            " 
            v-clipboard:copy="landUrl"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
                {{$t(`Copy`)}}
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 0px;" v-if="landId != '' && no_land == false">
          <!-- <div class="col-lg-2" style="text-align: left;">
            <n-button
              type="primary"
              v-clipboard:copy="landUrl"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >{{$t(`Copy`)}}</n-button>
          </div>-->
        </div>
        <div class="row" style="margin-top: 200px;" v-if="no_land == true">
          <div data-aos="fade-right" class="col-lg-12" style="text-align: center;">
            <h1
              class="description"
              style="
            font-size: 3em;
            font-weight: 900;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #fff;
            "
            >{{$t(`info_no_land`)}}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax, Button, FormGroupInput } from "@/components";
import { Popover } from "element-ui";
import axios from "axios";
import config from "../config.js";

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    Parallax,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Popover.name]: Popover
  },
  methods: {
    changeLandId: async function(landId) {
      if (landId == null) {
        this.landId = "";
        this.no_land = false;
      } else {
        let landInfo = await this.getLandInfo(landId);
        if (landInfo != null) {
          this.no_land = false;
          this.landInfo = landInfo;
          this.landId = this.$route.params.landId;
          this.inputLandId = this.landId;

          this.landUrl = `${config.web.url}/land/${this.landId}`;
        } else {
          this.no_land = true;
        }
      }
    },
    getEtherScanUrl: function(address) {
      return `${config.etherscan.account}/${address}`;
    },
    getHexColor: function(number) {
      return "#" + (number >>> 0).toString(16).slice(-6);
    },
    getLandInfo: function(landId) {
      console.log("getLandInfo - ", landId);
      return new Promise(resolve => {
        axios
          .get(`${config.api.game_url}/land/info?landId=${landId}`, {})
          .then(ret => {
            console.log("ret.data - ", ret.data);
            if (ret.data.result == true) {
              resolve(ret.data.land);
            } else {
              resolve(null);
            }
          });
      });
    },
    searchLand: function() {
      if (this.inputLandId == this.landId) {
        return;
      }
      this.$router.push(`/land/${this.inputLandId}`);
    },
    onCopy: function() {
      alert(this.$t(`info_copied`));
    },
    onError: function() {}
  },
  watch: {
    "$route.params.landId": function(landId) {
      this.changeLandId(landId);
    }
  },
  computed: {
    landLocation() {
      if (this.landId == "") {
        return [0, 0];
      }
      let landId = parseInt(this.landId);
      landId = landId % 100000;
      let landX = landId % 256;
      let landY = 255 - Math.floor(landId / 256);
      return [landX * (640.0 / 256.0), landY * (640.0 / 256.0)];
    }
  },
  async mounted() {
    this.changeLandId(this.$route.params.landId);
  },
  data: function() {
    return {
      landId: "",
      landInfo: {},
      landUrl: "",
      inputLandId: "",
      no_land: false
    };
  }
};
</script>
<style>
table,
th,
td {
  border: 0px solid white !important;
  min-width: 0px !important;
  min-height: 0px !important;
}

input,
textarea:focus {
  outline: none;
}

.land-info-title {
  position: absolute;
  top: 3px;
  width: 441px;
  height: 50px;
  text-align: center;
  color: white;
}
.land-info-area {
  position: absolute;
  top: 210px;
  right: 28px;
  width: 441px;
  height: 665px;
  overflow: none;
  background-image: url("/img/frame_field_info_2.png");
}
</style>
